import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { PopinPriceDetailComponent } from '@components/popin-price-detail';
import { SliderImplantations } from '@components/slider-implantations/models';
import { TranslatePipe } from '@ngx-translate/core';
import { ImageComponent } from '@shared/components/image';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';
import { KitchenLight } from '@shared/models';
import { DialogService } from '@shared/services/dialog';

@Component({
  selector: 'app-slider-implantations',
  imports: [TitleComponent, ImageComponent, SvgComponent, TranslatePipe],
  templateUrl: './slider-implantations.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SliderImplantationsComponent extends AbstractDynamicComponent<SliderImplantations> {
  private readonly dialogService = inject(DialogService);

  openPriceDetailsDialog(kitchen: KitchenLight): void {
    this.dialogService.openDialog(PopinPriceDetailComponent, 'BIG', {
      data: {
        id: kitchen.id,
        shortRef: kitchen.implantation?.shortRef,
      },
    });
  }
}
